import type { QuoteFilter } from '../hooks/useQuotesSelection'

interface Props {
  filter: QuoteFilter
  onFilterChange: (f: QuoteFilter) => void
  onCollapseAll: () => void
  onExpandAll: () => void
  allCollapsed: boolean
  onAutoSelectMin: () => void
  autoCandidates: number
  // Кнопка сохранения перенесена сюда из отдельного блока внизу страницы —
  // чтобы при длинных списках позиций она всегда была в зоне видимости (sticky).
  isDirty: boolean
  isSaving: boolean
  saveError: string | null
  onSave: () => void
}

const FILTER_LABELS: Record<QuoteFilter, string> = {
  all: 'Все',
  ready: 'Готовы',
  waiting: 'Ждут',
  'no-quotes': 'Без квот',
}

export function QuotesFilterBar({
  filter,
  onFilterChange,
  onCollapseAll,
  onExpandAll,
  allCollapsed,
  onAutoSelectMin,
  autoCandidates,
  isDirty,
  isSaving,
  saveError,
  onSave,
}: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap justify-between">
      <div className="inline-flex rounded-lg bg-gray-100 dark:bg-gray-800 p-0.5">
        {(['all', 'ready', 'waiting', 'no-quotes'] as QuoteFilter[]).map((key) => (
          <button
            key={key}
            type="button"
            onClick={() => onFilterChange(key)}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              filter === key
                ? 'bg-white dark:bg-gray-900 shadow text-gray-900 dark:text-gray-100 font-medium'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            {FILTER_LABELS[key]}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {saveError && <span className="text-xs text-red-600 dark:text-red-400">{saveError}</span>}
        <button
          type="button"
          onClick={allCollapsed ? onExpandAll : onCollapseAll}
          className="px-3 py-1.5 text-sm rounded-md border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800/50"
        >
          {allCollapsed ? 'Развернуть все' : 'Свернуть все'}
        </button>
        <button
          type="button"
          disabled={autoCandidates === 0}
          onClick={onAutoSelectMin}
          className="px-3 py-1.5 text-sm rounded-md font-medium bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-200 disabled:text-gray-400 dark:disabled:bg-gray-700"
        >
          Авто: минимальные цены
          {autoCandidates > 0 && ` (${autoCandidates})`}
        </button>
        <button
          type="button"
          disabled={!isDirty || isSaving}
          onClick={onSave}
          className={`px-3 py-1.5 text-sm rounded-md font-medium transition-colors ${
            isDirty
              ? 'bg-brand-600 text-white hover:bg-brand-700'
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'
          } disabled:opacity-60`}
        >
          {isSaving ? 'Сохранение…' : 'Сохранить выбор'}
        </button>
      </div>
    </div>
  )
}
